module.exports = __webpack_public_path__ + "images/category_lp/car/main-bg_224991d6f3d9a4af93f545ced3bf0318.jpg";